import { render, staticRenderFns } from "./ImagePlacementInput.vue?vue&type=template&id=d656949e&"
import script from "./ImagePlacementInput.vue?vue&type=script&lang=js&"
export * from "./ImagePlacementInput.vue?vue&type=script&lang=js&"
import style0 from "./ImagePlacementInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports